import Template from "backbone/projects/templates/registration.js.hamlc"
import RegistrationActionsView from "backbone/projects/views/registration_actions_view.js"
import RegistrationStep from "backbone/projects/models/registration_step.js"
import ProjectsViewState from "backbone/projects/models/projects_view_state.js"
import ImportStatusView from "backbone/projects/views/import_status_view.js"
import ProjectsCollection from "backbone/projects/collections/projects_collection.js"
import ProjectsView from "backbone/projects/views/projects_view.js"
import ProjectView from "backbone/projects/views/project_view.js"
import ScrapePublicationView from "backbone/projects/views/scrape_publication_view.js"
import ImportViaExternalServiceView from "backbone/projects/views/import_via_external_service_view.js"
import NewProjectView from "backbone/projects/views/new_project_view.js"
import Inflector from 'utils/platform/inflector.js'

export default class RegistrationView extends Backbone.View
  events:
    "click .js-switch-method"    : "switchAddProjectMethod"
    "click .js-next"             : "nextAction"
    "click .js-review-tab"       : "moveToReview"
    "click .js-back"             : "resetView"

  initialize: (options) ->
    @inflector = new Inflector()
    @portfolioUrl = options.portfolioUrl
    @registrationStep = new RegistrationStep
      showSkip: options.showSkip
    @actionsView = new RegistrationActionsView
      registrationStep: @registrationStep
      addSkillsUrl: options.addSkillsUrl
    @listenTo(@registrationStep, "change", @render)
    @finishLaterUrl = options.finishLaterUrl
    @subviews = []
    @render()

  render: ->
    @removeSubviews()

    currentStep = @registrationStep.get("currentStep")
    @$el.html(Template(registrationStep: @registrationStep))
    @actionsView.setElement(@$el.find(".js-actions"))
    @actionsView.render()

    switch @registrationStep.get("currentStep")
      when "addProject"
        @injectAddFormView()
      when "import"
        @viewState = new ProjectsViewState
        @subviews = []
        statusView = new ImportStatusView
          el: @$el.find(".js-status")
          collection: @pendingCollection
          importComplete: @moveToReview
        statusView.render()
        @subviews.push statusView
        for project in @pendingCollection.models
          @addProjectView(project)
      when "review"
        @projectsView.remove() if @projectsView
        @collection = new ProjectsCollection
        @projectsView = new ProjectsView(
          el: @$el.find("#projects")
          collection: @collection
        )

  saveAndFinishLater: ->
    window.location = @finishLaterUrl

  addProjectView: (project) ->
    projectView = new ProjectView
      project: project
      collection: @pendingCollection
    @subviews.push(projectView)
    @$el.find(".js-projects").append(projectView.render().el)
    projectView.create()

  switchAddProjectMethod: (e) ->
    $target = $($(e.target).closest(".js-switch-method"))
    return if $target.hasClass("active")
    @registrationStep.set(addMethod: $target.data("method"))
    @render()

  moveToReview: (projectsCollection) =>
    @addFormView.remove() if @addFormView
    if projectsCollection && projectsCollection.length
      numProjects = @inflector.pluralize("project", projectsCollection.length)
      contently.flash.notice("Successfully added " + numProjects + " to your portfolio.")
    @registrationStep.set(currentStep: "review", showSkip: true)

  nextStep: =>
    @registrationStep.nextStep()

  nextAction: (e) ->
    currentStep = @registrationStep.get("currentStep")
    if currentStep == "addProject"
      @addFormView.next()
    else
      @nextStep()

  injectAddFormView: ->
    @removeSubviews()
    $formTarget = @$el.find(".js-form-target")
    selectedMethod = @registrationStep.get("addMethod")
    switch selectedMethod
      when "scrapeClient"
        @pendingCollection = new ProjectsCollection
        @addFormView = new ScrapePublicationView(
          el: $formTarget
          collection: @pendingCollection
          afterSearch: @nextStep
        ).render()
      when "external"
        @pendingCollection = new ProjectsCollection
        @addFormView = new ImportViaExternalServiceView(
          el: $formTarget
          collection: @pendingCollection
          afterSearch: @nextStep
        ).render()
      else
        @addFormView = new NewProjectView(
          el: $formTarget
          onCreate: @moveToReview
          urlBased: if selectedMethod == "pdf" then false else true
        ).render()

  onCreate: (projectData) =>
    @newProjectView = null
    @collectionView.collection.add(projectData, at: 0)
    contently.flash.success "Your new project has been added."

  resetView: ->
    @addFormView.remove() if @addFormView
    @registrationStep.reset()

  remove: ->
    @removeSubviews()

  removeSubviews: ->
    @addFormView.remove() if @addFormView
    for subview in @subviews
      subview.remove()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/registration_view.js.coffee